export const deleteExpandableTablesData = (props) => {
  const {
    selectedVal,
    entityData,
    setEntityData,
  } = props.dataObject;
  const { tables, allowedConditionValues } = props.operation;
  if (tables && allowedConditionValues.includes(selectedVal)) {
    tables.forEach((table) => {
      delete entityData[table];
    });
    setEntityData({ ...entityData });
  }
};
